export enum Language {
    English = 1,
    Afrikaans = 2,
    Both = 3
}